import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import {Inputimg,App} from './App';
import Canny from './Canny';
import Smooth from './Smooth';
import Editcv from './editcv';
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css"

ReactDOM.render(
  <React.StrictMode>
    <Inputimg/>
    <App/>
    {/* <App /> */}
    {/* <Smooth inputImg="imageSrc"/> */}
    {/* <Canny/> */}

  </React.StrictMode>,
  document.getElementById('root')
);

